import { RestHelper } from '../helpers/RestHelper';

export class DownloadService {

  private _restHelper;

  constructor() {
    this._restHelper = new RestHelper();
  }

  async DownloadFile(payload : any)  {
    const url : string  = "Download/DownloadFile";
    let response = await this._restHelper.downloadFile(url, payload);
    return response;
  }
}
